import React from "react";
import CalendarHeatmap from "react-calendar-heatmap";

import { DailyStats } from "@/types/stats";

interface FailureCalendarProps {
  dailyBreakdown: DailyStats[];
}

export const FailureCalendar: React.FC<FailureCalendarProps> = ({ dailyBreakdown }) => {
  const values = dailyBreakdown.map((day) => ({
    date: day.date,
    count: day.failure,
    success: day.success,
  }));

  const endDate = new Date();
  const startDate = new Date();
  startDate.setMonth(startDate.getMonth() - 3);

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <h3 className="mb-1 text-lg font-semibold text-slate-900 dark:text-white">Failure Heatmap</h3>
      <p className="mb-4 text-sm text-slate-500 dark:text-slate-400">
        Days with more failures are darker. Hover for details.
      </p>
      <CalendarHeatmap
        startDate={startDate}
        endDate={endDate}
        values={values}
        classForValue={(value) => {
          if (!value || value.count === 0) return "color-empty";
          if (value.count >= 10) return "color-scale-4";
          if (value.count >= 5) return "color-scale-3";
          if (value.count >= 2) return "color-scale-2";
          return "color-scale-1";
        }}
        titleForValue={(value) =>
          value
            ? `${value.date}: ${value.count} failure${value.count !== 1 ? "s" : ""} / ${value.count + value.success} total requests`
            : "No data"
        }
      />
      <div className="mt-4 flex items-center justify-end gap-2 text-sm text-slate-500 dark:text-slate-400">
        <span>Less</span>
        <span className="h-3 w-3 rounded bg-red-300/40" />
        <span className="h-3 w-3 rounded bg-red-400/60" />
        <span className="h-3 w-3 rounded bg-red-500/80" />
        <span className="h-3 w-3 rounded bg-red-600" />
        <span>More</span>
      </div>
    </div>
  );
};
